"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPES = void 0;
exports.TYPES = {
    ChainsStore: Symbol("ChainsStore"),
    ChainsEmbedChainInfos: Symbol("ChainsEmbededChainInfos"),
    InteractionStore: Symbol("InteractionStore"),
    KeyRingStore: Symbol("KeyRingStore"),
    LedgerStore: Symbol("LedgerStore"),
    LedgerOptions: Symbol("LedgerOptions"),
    PermissionStore: Symbol("PermissionStore"),
    PermissionServicePrivilegedOrigins: Symbol("PermissionServicePrivilegedOrigins"),
    PersistentMemoryStore: Symbol("PersistentMemoryStore"),
    SecretWasmStore: Symbol("SecretWasmStore"),
    TokensStore: Symbol("TokensStore"),
    TxStore: Symbol("TxStore"),
    UpdaterStore: Symbol("UpdaterStore"),
    EventMsgRequester: Symbol("EventMsgRequester"),
    RNG: Symbol("RandomNumberGenerator"),
    CommonCrypto: Symbol("CommonCrypto"),
    Notification: Symbol("Notification"),
};
//# sourceMappingURL=types.js.map